/* eslint-disable max-len */
import React from 'react';

const H4Icon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path
      fill="currentColor"
      d="M2.75 14.996v-4.508H7.3v4.508h1.75V5H7.3v3.976H2.75V5H1v9.996h1.75zm13.384 0v-2.324h1.26v-1.26h-1.26V5.196h-1.512l-4.2 5.894v1.582h4.2v2.324h1.512zm-1.512-3.584h-2.968l2.94-4.312h.028v4.312z"
    />
  </svg>
);

export default H4Icon;
